import { render, staticRenderFns } from "./newsletterO.vue?vue&type=template&id=2e3b0dc1&scoped=true"
import script from "./newsletterO.vue?vue&type=script&lang=js"
export * from "./newsletterO.vue?vue&type=script&lang=js"
import style0 from "./newsletterO.vue?vue&type=style&index=0&id=2e3b0dc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b0dc1",
  null
  
)

export default component.exports